import axios, { AxiosRequestConfig } from 'axios'
import {
  ReadUserBankAccountsRequestDto,
  ReadUserBankAccountsResponseDto,
  UpdateUserBankAccountResponseDto,
  UpdateUserBankAccountStatusRequestDto,
} from '@sparling/financial-common'
import { isNil } from 'lodash'

export const getUserBankAccounts = async (
  { token, idSf, ...params }: ReadUserBankAccountsRequestDto & { token: string; idSf: string },
  options: AxiosRequestConfig = {},
): Promise<ReadUserBankAccountsResponseDto> => {
  const response = await axios.get<ReadUserBankAccountsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/user/${idSf}/bank-accounts`,
    {
      params: Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== '')),
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}

export const updateUserBankAccountStatus = async (
  { token, id, ...params }: UpdateUserBankAccountStatusRequestDto & { token: string },
  options: AxiosRequestConfig = {},
): Promise<UpdateUserBankAccountResponseDto> => {
  const url = `${process.env.REACT_APP_SERVER_URL}/crm/user/bank-accounts/${id}`
  const body = Object.fromEntries(Object.entries(params).filter(([, value]) => !isNil(value) && value !== ''))
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  }

  const response = await axios.patch<UpdateUserBankAccountResponseDto>(url, body, config)

  return response.data
}
